module.exports = __webpack_public_path__ + "img/neirong.177be808.svg";